export var CORES_STATUS_REGISTRO_DIARIO = {
    "CRIADO": {
        pure: {
            color: "#3B84FF",
            textColor: "#000000"
        },
        dark: {
            color: "#0058CB",
            textColor: "#ffffff"
        },
        light: {
            color: "#BFD7FF",
            textColor: "#000000"
        }
    },
    "AGUARDANDO_AUTORIZACAO": {
        pure: {
            color: "#FFA928",
            textColor: "#000000"
        },
        dark: {
            color: "#A66600",
            textColor: "#ffffff"
        },
        light: {
            color: "#FFE3B9",
            textColor: "#000000"
        }
    },
    "AGUARDANDO_CORRECAO": {
        pure: {
            color: "#EF343B",
            textColor: "#000000"
        },
        dark: {
            color: "#b50014",
            textColor: "#ffffff"
        },
        light: {
            color: "#FFBEC0",
            textColor: "#000000"
        }
    },
    "ENVIO_AUTORIZADO": {
        pure: {
            color: "#5BDB3A",
            textColor: "#000000"
        },
        dark: {
            color: "#008100",
            textColor: "#ffffff"
        },
        light: {
            color: "#D4F3CC",
            textColor: "#000000"
        }
    },
    "ENVIANDO": {
        pure: {
            color: "#BC3BD2",
            textColor: "#000000"
        },
        dark: {
            color: "#5E0B6C",
            textColor: "#ffffff"
        },
        light: {
            color: "#F7C8FF",
            textColor: "#000000"
        }
    },
    "ENVIADO": {
        pure: {
            color: "#8A8787",
            textColor: "#000000"
        },
        dark: {
            color: "#4C4747",
            textColor: "#ffffff"
        },
        light: {
            color: "#C7C7C7",
            textColor: "#000000"
        }
    }
};
